// extracted by mini-css-extract-plugin
var _1 = "Mention-module__animateUploadProgressBarWidth--vnsXD";
var _2 = "Mention-module__animatedBackground--j5Pp6";
var _3 = "Mention-module__container--Z_xjH";
var _4 = "Mention-module__content--mcma0";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "content" }
